import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { OpenFileLink } from '../../common/components/data-display';
import PagesLayout from './PagesLayout';

const DokumentyNaStiahnutie = ({ t }) => (
  <PagesLayout className="stiahnutie">
    <h1>{t('Dokumenty na stiahnutie')}</h1>
    <ul className="disc" style={{ marginTop: 20 }}>
      <li>
        <OpenFileLink href="/documents/Reklamacny poriadok.pdf">
          {t('Reklamačný poriadok')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Ochrana osobnych udajov.pdf">
          {t('Ochrana osobných údajov')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Podmienky pouzivania portalu Majak.sk.pdf">
          {t('Pravidlá používania stránky')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Informacne povinnosti predavajuceho - Dlznik.pdf">
          {t('Informačné povinnosti poskytovateľa služieb - Dlžník')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Informacne povinnosti predavajuceho - Investor.pdf">
          {t('Informačné povinnosti poskytovateľa služieb - Investor')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Group_PA_AD_07_18.pdf">
          {t('Osobitné poistné podmienky pre skupinové úrazové poistenie pre poistenie pre prípad smrti následkom úrazu ')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Group_PA_VPP_B_07_18.pdf">
          {t('Všeobecné poistné podmienky pre prípad straty končatiny, zraku, sluchu alebo reči následkom úrazu, chirurgického zákroku, hospitalizácie, zlomenín a popálenín, dočasnej pracovnej neschopnosti, nevyhnutného liečenia úrazu, smrti následkom úrazu alebo trvalých následkov úrazu')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/IPID_25_5_FINAL.pdf">
          {t('Skupinové úrazové poistenie - Informačný dokument o poistnom produkte')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/OPP_ILOE_strata_zamestnania.pdf">
          {t('Poistné podmienky pre pripoistenie pre prípad nedobrovoľnej straty zamestnania "Credit Life"')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Oznamenie_poistnej_udalosti_11032022.pdf">
          {t('Poistné hlásenie C Vyhlásenie osoby uplatňujúcej si nárok')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Dokument_o_dolezitych_zml.podmienkach.pdf">
          {t('Dokument o dôležitých zmluvných podmienkach uzatváranej poistnej zmluvy poistenia schopnosti splácať pôžičku')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Prehlad_poistneho_krytia.pdf">
          {t('Prehľad poistného krytia')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Ramcova_poistna_zmluva.pdf">
          {t('Rámcová poistná zmluva pre poistenie schopnosti splácať pôžičku')}
        </OpenFileLink>
      </li>
      <li>
        <OpenFileLink href="/documents/Vseobecne_poistne_podmienky.pdf">
          {t('Všeobecné poistné podmienky poistenia "Credit Life", Osobitné poistné podmienky pre pripoistenie pre prípad úplnej trvalej invalidity "Credit Life", Osobitné poistné podmienky pre pripoistenie pre prípad úplnej dočasnej invalidity "Credit Life"')}
        </OpenFileLink>
      </li>
    </ul>
  </PagesLayout>
);

DokumentyNaStiahnutie.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate()(DokumentyNaStiahnutie);



// WEBPACK FOOTER //
// ./src/features/pages/DokumentyNaStiahnutie.js